import { ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Platform } from 'react-native';
import { config } from '../config';

export type MantraAppInfoHeaders = {
  'X-Mantra-App-Name': string;
  'X-Mantra-App-Platform': string;
  'X-Mantra-App-Version': string;
  'X-Mantra-App-Build': string;
  /** User-Agent string for mobile */
  'User-Agent'?: string;
};

export const getMantraAppInfoHeaders = (): MantraAppInfoHeaders => {
  const { version, build } = config;
  const name = 'hub';

  const headers: MantraAppInfoHeaders = {
    'X-Mantra-App-Name': name,
    'X-Mantra-App-Platform': Platform.OS,
    'X-Mantra-App-Version': version,
    'X-Mantra-App-Build': build,
  };

  if (Platform.OS === 'web') {
    // do not include the user agent on web, we want to know what browser is used
    return headers;
  }

  // include the user agent on mobile in order to obscure the http client used
  // for security purposes
  return {
    ...headers,
    'User-Agent': `mantra-hub-${Platform.OS}/${version}+${build}`,
  };
};

export const mantraAppInfoLink: ApolloLink = setContext((request, { headers }) => {
  const mantraAppInfoHeaders = getMantraAppInfoHeaders();

  return {
    headers: {
      ...headers,
      ...mantraAppInfoHeaders,
    },
  };
});
